const React = require('react');
const PropTypes = require('prop-types');


const { formatText } = require('core/i18n').i18n;
const dateHelper = require('utilities/dateHelper');
const { padLeftWithZeros } = require('utilities/stringHelper');

class DateText extends React.Component {
    durationBetweenDate(start, end){
        const date = dateHelper.durationBetweenDate(start, end)

        // return date.format('YY MM DD HH:MM')
        const dateParts = ['hours', 'minutes', 'seconds']
            .map(elm => padLeftWithZeros(date.get(elm)) || '00')
        return `${dateParts[0]}:${dateParts[1]}:${dateParts[2]}`
        // const datePart = ['years', 'months', 'days', 'hours', 'minutes', 'seconds'].find(elm => date.get(elm) > 0) || 'seconds'
        // const dateTime = date.get(datePart)
        // const text = dateTime > 1 ? datePart : datePart.slice(0, -1)
        // return `${dateTime} ${formatText(`datetime-${text}`)}`
    }

    textOrDate(date) {
        if (dateHelper.isToday(date))
            return formatText('dateText-today')
        if (dateHelper.isYesterday(date))
            return formatText('dateText-yesterday')
        return dateHelper.customNormalFormat(date, 'DD MMM YYYY')
    }

    resolveFormat = () => {
        const { text, format, textEnd } = this.props

        const mapper = {
            betweenDates: this.durationBetweenDate(text, textEnd),
            textOrDate: this.textOrDate(text)
        }
        
        return mapper[format] || dateHelper.customNormalFormat(text, format)
    }

    render() {
        return (
            <span className={this.props.customClassName}>{this.resolveFormat()}</span>
        );
    }
}

DateText.propTypes = {
    customClassName: PropTypes.string,
    text: PropTypes.string,
    textEnd: PropTypes.string,
    format: PropTypes.string
}

DateText.defaultProps = {
    customClassName: "",
    text: "",
    textEnd: "",
    format: ""
}

module.exports.constructor = DateText
module.exports.DateText = DateText